import { connect } from 'react-redux';
import {
  dispatcher as dispatcherSelectors,
  regressionPage as regressionPageSelectors
} from '../selectors';
import {
  dispatchersReducer,
  paramsReducer
} from '../reducers';
import { actionTypes as actionTypeHelpers } from '../helpers';
import DispatcherInfoComponent from '../Components/DispatcherInfoComponent';

const ACTIONS_TO_DISPLAY = [ actionTypeHelpers.OPEN_JOB_URL ];

const mapStateToProps = (state) => {
  const dispatcherJobInfo = dispatcherSelectors.getDispatcherJobInfo(state);
  const props = {
    dispatcher: dispatchersReducer.getDispatcherById(
      state, dispatcherJobInfo.dispatcherId
    ),
    dispatcherDropdownActions: regressionPageSelectors.getDispatcherActions(
      state, dispatcherJobInfo, ACTIONS_TO_DISPLAY
    ),
    dispatcherJobInfo,
    dispatcherParams: paramsReducer.getParamsByJobId(state, dispatcherJobInfo.jobId),
  };
  return props;
};

const mapDispatchToProps = (dispatch) => {
  const props = { onActionButtonClick: (buttonAction) => dispatch(buttonAction) };
  return props;
};

const DispatcherInfoContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatcherInfoComponent);

export default DispatcherInfoContainer;

export const testingExports = {
  ACTIONS_TO_DISPLAY,
  mapStateToProps,
  mapDispatchToProps
};


// WEBPACK FOOTER //
// src/Containers/DispatcherInfoContainer.jsx